module.exports = __webpack_public_path__ + "static/media/landingimage.c5ce6fae.svg";